/**
 * Shared ELF-CIRCLE chrome.
 *
 * Owns the palette scope (`data-palette` lives on this root), the floating
 * theme bar, the CMS provider and the consultation dialog. The dialog's
 * provider lives in App, above the router, so a page component can open the
 * dialog from its own body. Both the landing page and every inner page mount
 * inside this shell, so they share one palette and one set of admin controls.
 */

import React, { useRef, type ReactNode } from 'react';
import ElfConsultModal from './ElfConsultModal';
// import ElfThemeBar from './ElfThemeBar';
import ElfVizor from './ElfVizor';
import { ElfThemeProvider } from './elfTheme';
import { useElfPalette } from './useElfPalette';
import { useTouchMotion } from './useTouchMotion';
import { LandingImagesProvider } from './useLandingImages';
import './elf-landing.css';
import './elf-pages.css';

export const ElfShell: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { family, mode, setFamily, setMode, rootRef } = useElfPalette();
  // Hover's motion, restored on touch screens by scroll and entrance. Scoped
  // to the content wrapper: the root's ref belongs to the palette hook and is
  // a callback ref, which has no `.current` to observe from.
  const shellRef = useRef<HTMLDivElement>(null);
  useTouchMotion(shellRef);

  return (
    <div ref={rootRef} className="elf">
      <ElfThemeProvider value={{ mode, setMode, family, setFamily }}>
        {/* Floating palette bar — hidden for now.
        <ElfThemeBar family={family} mode={mode} onFamilyChange={setFamily} onModeChange={setMode} />
        */}
        <LandingImagesProvider>
          <div className="elf-shell" ref={shellRef}>
            {children}
          </div>
        </LandingImagesProvider>
        {/* The dialog stays inside `.elf` — its CSS and palette variables are
            scoped to this root. Only the provider lives higher, in App. */}
        <ElfConsultModal />
        {/* Renders nothing until the server confirms Vizor is configured. */}
        <ElfVizor />
      </ElfThemeProvider>
    </div>
  );
};

export default ElfShell;
